<script>
  export let width = 12;
  export let height = 12;
  export let fill = "currentColor";
</script>

<svg xmlns="http://www.w3.org/2000/svg" {width} {height} viewBox="0 0 512 512">
  <defs />

  <path
    {fill}
    d="M414.57 268.86l-212 212q-5.43 5.43-12.86 5.43t-12.85-5.43l-47.43-47.43Q124 
428 124 420.57t5.43-12.85L281.14 256 129.43 104.3Q124 98.86 124 91.43t5.43-12.86l47.43-47.42q5.43-5.43 
12.85-5.43t12.86 5.43l212 212Q420 248.57 420 256t-5.43 12.86z" />
</svg>
